module.exports = __webpack_public_path__ + "static/media/img81.55328217.jpg";